export const formOrderObjFromCart = (data = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    return {
        entityDetails: {
            ...entityDetails,
        },
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && { appProfileDetails: { label: entityDetails?.name, value: entityDetails?.name } }),
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        appRegion: catalogConfig?.applicationRegion || null,
        department: catalogConfig?.department || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        ...(catalogConfig?.environmentDetails?.environment === 'Production' && {
            isHighAvailability: catalogConfig?.highAvailability === true ? 'yes' : 'no',
        }),
        awsAccountId: catalogConfig?.awsAccountId,
        tableName: catalogConfig?.tableName,
        tableClass: catalogConfig?.tableClassName,
        tableClassCode: catalogConfig?.tableClassCode,
        partitionKey: catalogConfig?.partitionKey,
        partitionKeyType: catalogConfig?.partitionKeyType,
        sortKey: catalogConfig?.sortKey,
        sortKeyType: catalogConfig?.sortKeyType,
        capacityMode: catalogConfig?.capacityMode,
        readCapacityUnits: catalogConfig?.provisionedReadUnits,
        writeCapacityUnits: catalogConfig?.provisionedWriteUnits,
        encryption: catalogConfig?.encryption,
        timeToLive: catalogConfig?.timeToLive,
        ttlAttribute: catalogConfig?.ttlAttribute,
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    return {
        entityDetails: {
            ...entityDetails,
        },
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && { appProfileDetails: { label: entityDetails?.name, value: entityDetails?.name } }),
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        appRegion: catalogConfig?.applicationRegion || null,
        department: catalogConfig?.department || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        ...(catalogConfig?.environmentDetails?.environment === 'Production' && {
            isHighAvailability: catalogConfig?.highAvailability === true ? 'yes' : 'no',
        }),
        awsAccountId: catalogConfig?.awsAccountId,
        tableName: catalogConfig?.tableName,
        tableClass: catalogConfig?.tableClassName,
        tableClassCode: catalogConfig?.tableClassCode,
        partitionKey: catalogConfig?.partitionKey,
        partitionKeyType: catalogConfig?.partitionKeyType,
        sortKey: catalogConfig?.sortKey,
        sortKeyType: catalogConfig?.sortKeyType,
        capacityMode: catalogConfig?.capacityMode,
        readCapacityUnits: catalogConfig?.provisionedReadUnits,
        writeCapacityUnits: catalogConfig?.provisionedWriteUnits,
        encryption: catalogConfig?.encryption,
        timeToLive: catalogConfig?.timeToLive,
        ttlAttribute: catalogConfig?.ttlAttribute,
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time cost',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'per item per month',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};
export const resetOrder = {
    entityDetails: null,
    appProfile: null,
    appProfileDetails: null,
    sector: null,
    environment: null,
    appRegion: null,
    department: null,
    landingZoneDetails: null,
    applicationShortName: null,
    hCode: null,
    hCodeDetails: null,
    appOwner: null,
    appOwnerDetails: null,
    awsAccountId: null,
    awsAccountName: null,
    tableName: null,
    tableClass: null,
    tableClassCode: null,
    partitionKey: null,
    partitionKeyType: null,
    sortKey: null,
    sortKeyType: null,
    capacityMode: 'PAY_PER_REQUEST',
    readCapacityUnits: null,
    writeCapacityUnits: null,
    encryption: 'Default',
    timeToLive: 'Enabled',
    ttlAttribute: null,
    catalogCode: null,
    catalogType: null,
    cloudProvider: null,
    cloudService: null,
    validationStatus: null,
    isTouched: null,
};
export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isSubmitOrderSuccess: false,
    isCostSplitOpen: false,
};
